module.exports = "/_next/static/images/slide3-eb4dcb7cb94a6e750a9958204454b501.jpg.webp";